export default __webpack_public_path__ + "img/person.77c1722c.svg";